module.exports = __webpack_public_path__ + "static/media/Group 111.49347826.svg";